import React from 'react';
import { useFormikContext } from 'formik';

import SalesTeamSearch from '@components/form/search/SalesTeamSearch';
import SociollaErrorMessage from './SociollaErrorMessage';

// eslint-disable-next-line react/prop-types
function SociollaSalesTeamSearch({ name, onChange, ...otherProps }) {
  const { setFieldValue, errors, touched, values } = useFormikContext();

  return (
    <>
      <SalesTeamSearch
        onChange={async (value) => {
          await setFieldValue(name, value);
          if (onChange) {
            onChange(value);
          }
        }}
        value={values[name]}
        {...otherProps}
      />
      <SociollaErrorMessage error={errors[name]} visible={touched[name]} />
    </>
  );
}

export default SociollaSalesTeamSearch;
